"use strict";
exports.__esModule = true;
exports.chart_pie_Width = {
  "name": "--pf-chart-pie--Width",
  "value": 230,
  "var": "var(--pf-chart-pie--Width, 230)"
};
exports["default"] = exports.chart_pie_Width;